import AppPageTitle from "@/components/AppPageTitle";
import AppIcon from "@/components/AppIcon";
import AppButton from "@/components/AppButton";
import { sortData } from "@/utils";
export default {
  name: "ConnectionFailed",
  components: {
    AppPageTitle,
    AppIcon,
    AppButton
  },
  props: {
    title: {
      type: String,
      default: "Choose Amazon Ads Accounts"
    },
    errorTitle: {
      type: String,
      default: "No advertising profiles found for your Seller/Vendor account"
    },
    errorDetail: {
      type: String,
      default: "These are the all the advertising profiles that are available for your personal user but Omny couldn’t find a match. Please close this windows and restart the connection process with a user authorized on the Amazon Advertising Account corresponding to your Seller/Vendor Account."
    },
    supportText: {
      type: String,
      default: "If you’re unable to find the issue and need help, contact us to resolve your queries"
    }
  },
  methods: {
    onClick() {
      window.location.href = "mailto:support@get-omny.com";
    }
  }
};